import { useState } from 'react';
import styled from 'styled-components';
import remarkGfm from 'remark-gfm';
import Markdown from 'react-markdown';
import { Alert, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { StyledMarkdownWrapper } from './StyledMarkdownWrapper';

export const Disclaimer = () => {
  const { t } = useTranslation(undefined, { useSuspense: false });
  const [expanded, setExpanded] = useState(false);
  const text = t('chat.disclaimer');
  const preview = text.split('\n')?.[1]?.split('.')?.[0];
  const formattedText = text?.replaceAll(/<br\/?>/gi, '\n');
  const previewStyle = { textDecoration: 'underline', cursor: 'pointer' };
  const textStyle = { fontSize: 12 };
  if (expanded) {
    return (
      <StyledDisclaimerAlert
        type="info"
        message={
          <Typography.Text style={textStyle}>
            <StyledMarkdownWrapper $softTableBorder>
              <Markdown remarkPlugins={[remarkGfm]}>{formattedText}</Markdown>
            </StyledMarkdownWrapper>
          </Typography.Text>
        }
      />
    );
  }
  return (
    <Typography.Paragraph
      onClick={() => setExpanded(true)}
      type="secondary"
      style={previewStyle}
    >
      {preview}
    </Typography.Paragraph>
  );
};

const StyledDisclaimerAlert = styled(Alert)`
  h1 {
    margin: 0;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 2px;
  }
`;
